import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '../../firefly/component';
import { YMaps, Map, Clusterer, Placemark } from 'react-yandex-maps';

export default class StatPartnerFilter extends Component {
  static propTypes = {
    //notification: PropTypes.func.isRequired,
    //fetch: PropTypes.func.isRequired,
    //filter: PropTypes.object,
    //remove: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    success: PropTypes.bool,
    objects: PropTypes.array,
    //meta: PropTypes.object,
    //className: PropTypes.string
  };

  static defaultProps = {
    //loading: true,
    loading: false,
    //objects: [],    
    //filter: {},
    //meta: {},
    className: ''
  };
  
  render() {
    const {
      //className,
      loading,
      success,
      objects
    } = this.props;

    if (loading && !success) {
      return <Spinner />;
    }

    return (
      <div>
        <YMaps>
          <Map
            width={'100%'}
            height={500}
            defaultState={{
              center: objects.length > 0 ? objects[0] : [43.585378, 39.722786],
              zoom: 5
            }}
          >
            <Clusterer
              options={{
                preset: 'islands#invertedVioletClusterIcons',
                groupByCoordinates: false,
              }}
            >
            {objects.map((coordinates, index) => (
              <Placemark key={index} geometry={coordinates} />
            ))}
            </Clusterer>
          </Map>
        </YMaps>
      </div>
    );
  }
}
